const ActionButtonsSkeleton = () => {
  return (
    <div className="flex flex-col gap-[1.6rem]">
      <div className="flex flex-col gap-[1.6rem] xl:flex-row">
        <div className="h-[4.5rem] w-full animate-pulse rounded-full bg-brand-light-gray" />
        <div className="h-[4.5rem] w-full animate-pulse rounded-full bg-brand-light-gray" />
      </div>
      <div className="h-[4.5rem] w-full animate-pulse rounded-full bg-brand-light-gray" />
    </div>
  );
};

export default ActionButtonsSkeleton;
